/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    GROWTH_FUND_LEVEL_TITLE: {
        size: 35,
        color: new cc.Color(171, 121, 89, 255),
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_TITLE_REACHED: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_REWARD: {
        size: 35,
        color: new cc.Color(234, 219, 206, 255)
    },

    GROWTH_FUND_LEVEL_REWARD_REACHED: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.GREEN,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_LEVEL_VALUE_REACHED: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.GREEN,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_CTA2: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    GROWTH_FUND_CTA1: {
        color: new cc.Color(255, 198, 0, 255),
        stroke: {
            color: new cc.Color(191, 117, 0, 255),
            size: 2
        },
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    GROWTH_FUND_LEVEL_VALUE: {
        name: "nostroke",
        size: 35,
        color: new cc.Color(234, 219, 206, 255)
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundWindow, {
    margin: 10,
    padding: {
        top: 5
    },

    window: {
        padding: {
            left: 5,
            right: 5,
            top: 20,
            bottom: 20
        }
    },

    top: {
        width: 970,
        height: 350,

        text: {
            anchor: { x: 0.5, y: 0.5 },
            x: { align: "center", dx: 155 },
            y: { align: "center", dy: 80 }
        },

        icon: {
            x: { align: "center", dx: -150 },
            y: { align: "center", dy: -20 }
        },

        button: {
            height: 110,
            x: { align: "right", dx: -53 },
            y: { align: "bottom", dy: 70 }
        },

        mark: {
            x: { align: "right", dx: -140 },
            y: { align: "bottom", dy: 70 }
        }
    },

    scroll: {
        margin: 10,
        width: 1000,
        height: 710,

        top: {
            width: 1078,
            height: 52,
            x: { align: "center", dx: 0 },
            y: { align: "top", dy: 35 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundLevelView, {
    width: 970,
    height: 170,

    iconBg: {
        x: { align: "left", dx: 0 },
        y: { align: "center", dy: 0 },
        width: 260,
        height: 200
    },

    title: {
        x: { align: "left", dx: 295 },
        y: { align: "center", dy: 25 }
    },

    icon: {
        x: { align: "left", dx: 55 },
        y: { align: "center", dy: 0 }
    },

    rewards: {
        x: { align: "left", dx: 295 },
        y: { align: "center", dy: -25 }
    },

    button: {
        width: 230,
        height: 110,
        x: { align: "right", dx: -52 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.GrowthFundBuyWindow, {
    button: {
        height: 110
    }
});
